// src/components/layout/Layout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import "./Layout.css";

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />

      {menuOpen && (
        <div
          className="layout__scrim"
          role="presentation"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div className="layout__main">
        <div className="layout__topbar">
          <button
            type="button"
            className="icon-btn"
            aria-label="メニュー"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <i className="ti ti-menu-2" aria-hidden="true" />
          </button>
          <span className="layout__topbar-title">RUDO MANAGER</span>
        </div>

        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
